[
  {
    "id": "SR-M7P-BABYS-V01",
    "module": "SpellingRegel",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "meervoud",
    "familyId": "SR-MEERVOUD-Y-APOSTROF",
    "conceptId": "plural_y_apostrophe",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het juiste meervoud van 'baby'?",
    "options": [
      "baby's",
      "babies",
      "babys",
      "babyen"
    ],
    "correctAnswer": 0,
    "explanation": "Woorden die eindigen op een -y krijgen in het Nederlands een apostrof-s in het meervoud: baby's. Dit is anders dan in het Engels, waar het 'babies' wordt.",
    "distractorExplanations": {
      "1": "Dit is de Engelse meervoudsvorm. In het Nederlands gebruiken we een apostrof: baby's.",
      "2": "Zonder apostrof zou je 'babys' lezen als 'babbies'. De apostrof houdt de uitspraak correct.",
      "3": "Woorden op -y krijgen geen '-en' als meervoud. Ze krijgen apostrof-s: baby's."
    }
  },
  {
    "id": "SR-M7P-NIVEAU-V01",
    "module": "SpellingRegel",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "niveau",
      "nivo",
      "nievo",
      "nivau"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'niveau'. Dit is een Frans leenwoord. Je hoort 'nivo', maar je schrijft '-eau'. Andere voorbeelden: cadeau, bureau, plateau.",
    "distractorExplanations": {
      "1": "Dit is een fonetische schrijfwijze. Franse '-eau'-woorden behouden hun spelling: niveau.",
      "2": "De klinkers staan in de verkeerde volgorde. Het is '-eau', niet '-evo'.",
      "3": "De juiste Franse uitgang is '-eau', niet '-au'. Vergelijk: cadeau, bureau."
    }
  },
  {
    "id": "SR-M7P-LINIAAL-V01",
    "module": "SpellingRegel",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-LINIAAL",
    "conceptId": "tricky_vowel_combinations",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "liniaal",
      "lineaal",
      "liniael",
      "lyniaal"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'liniaal'. De klinkercombinatie is 'i-i-a': li-ni-aal. Let op: de tweede lettergreep is 'ni', niet 'ne'.",
    "distractorExplanations": {
      "1": "De tweede lettergreep is 'ni', niet 'ne'. Je schrijft: li-ni-aal.",
      "2": "Het woord eindigt op '-aal', niet op '-ael'. Vergelijk: materiaal, koloniaal.",
      "3": "Het woord begint met 'li', niet met 'ly'. Er zit geen 'y' in dit woord."
    }
  },
  {
    "id": "SR-M7P-MILJONAIR-V01",
    "module": "SpellingRegel",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-AIR",
    "conceptId": "french_air_ending",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "miljonair",
      "miljonnair",
      "miljonèr",
      "miljonar"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'miljonair'. Je hoort '-er', maar je schrijft '-air'. Dit is een Franse uitgang. Andere voorbeelden: solitair, secretaris → maar: miljonair.",
    "distractorExplanations": {
      "1": "Het woord heeft maar één 'n': mil-jo-nair, niet mil-jon-nair.",
      "2": "De Nederlandse spelling is '-air', niet '-èr'. We schrijven het als Frans leenwoord.",
      "3": "De uitgang is '-air', niet '-ar'. De 'i' is essentieel: miljon-air."
    }
  },
  {
    "id": "SR-M7P-TROTTOIR-V01",
    "module": "SpellingRegel",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-OIR",
    "conceptId": "french_oir_ending",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "trottoir",
      "trotoir",
      "trottoar",
      "trottwar"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'trottoir'. Het heeft een dubbele 't' in het midden en eindigt op '-oir' (Frans). Je hoort 'trot-waar', maar je schrijft 'trot-toir'.",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 't'. Het woord heeft een dubbele 't': trot-toir.",
      "2": "De uitgang is '-oir', niet '-oar'. Dit is een Franse spelling.",
      "3": "Je hoort 'waar', maar je schrijft '-oir'. Franse leenwoorden behouden hun spelling."
    }
  }
]